
const UserFrymes = ({ userCredits }) => {
  return (
    <>
      <p>
        <strong>Free frymes:</strong> {userCredits?.freeFrymesBalance || 0}
        &nbsp;||&nbsp;
        <strong>Used Free frymes:</strong> {userCredits?.usedFreeToday || 0}
        &nbsp;||&nbsp;
        <strong>Total paid frymes:</strong> {userCredits?.creditBought || 0}
        &nbsp;||&nbsp;
        <strong>Balance paid frymes:</strong> {userCredits?.balanceCredit || 0}
        &nbsp;||&nbsp;
        <strong>Used frymes:</strong> {userCredits?.usedCredit || 0}
      </p>

      {userCredits?.freeFrymesBalance === 0 && (
        <p style={{ color: "red" }}>
          Your monthly free frymes have been exhausted. Please wait until next
          month for renewal.
        </p>
      )}
    </>
  );
};

export default UserFrymes;

